"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initMortgageCalendar = initMortgageCalendar;
const firebase_1 = require("./firebase");
const firestore_1 = require("firebase/firestore");
const utils_1 = require("./utils");
const FIRESTORE_COLLECTION = "mortgage_calender";
const PAGE_SIZE = 9;
let lastDocument = null;
let selectedCategory = "Interest Rate";
function initMortgageCalendar(container) {
    container.innerHTML = `
      <div class="mortgage-calender">
        <div class="section-heading">Mortgage Calender</div>
        <div class="filters">
            <div class="filter selected">Interest Rate</div>
            <div class="filter">Gross domestic product, income, and expenditure</div>
            <div class="filter">Housing</div>
        </div>
        <div class="calendar-content">
            <div class="calendar-header"></div>
            <div class="calendar-events"></div>
        </div>
      </div>
    `;
    const mortgageCalender = container.querySelector(".mortgage-calender");
    const sectionHeading = container.querySelector(".section-heading");
    const filtersList = container.querySelector(".filters");
    const calendarEvents = container.querySelector(".calendar-events");
    const calendarHeader = container.querySelector(".calendar-header");
    if (!mortgageCalender || !sectionHeading || !calendarEvents)
        return;
    loadMortgageCalendarEvents(container);
    let isLoading = false;
    let hasMoreData = true;
    const handleScroll = () => __awaiter(this, void 0, void 0, function* () {
        const rect = calendarEvents.getBoundingClientRect();
        const isNearBottom = rect.bottom <= window.innerHeight + 100;
        if (!isLoading && hasMoreData && isNearBottom) {
            isLoading = true;
            try {
                hasMoreData = yield loadMortgageCalendarEvents(container);
            }
            catch (error) {
                console.error("Error loading mortgage calendar events:", error);
            }
            finally {
                isLoading = false;
            }
        }
    });
    const throttle = (func, limit) => {
        let lastCall = 0;
        return (...args) => {
            const now = Date.now();
            if (now - lastCall >= limit) {
                lastCall = now;
                func(...args);
            }
        };
    };
    window.addEventListener("scroll", throttle(handleScroll, 200));
    filtersList.addEventListener("click", (event) => {
        const target = event.target;
        if (target.closest(".filter")) {
            const filterElements = filtersList.querySelectorAll(".filter");
            filterElements.forEach(filterElement => {
                filterElement.classList.remove("selected");
            });
            target.classList.add("selected");
            selectedCategory = target.textContent ? target.textContent : "";
            lastDocument = null;
            calendarHeader.classList.remove("show", "three-col-layout");
            calendarEvents.innerHTML = "";
            calendarHeader.innerHTML = "";
            loadMortgageCalendarEvents(container);
        }
    });
}
function loadMortgageCalendarEvents(container) {
    return __awaiter(this, void 0, void 0, function* () {
        const calendarHeader = container.querySelector(".calendar-header");
        const calendarEvents = container.querySelector(".calendar-events");
        if (!calendarHeader || !calendarEvents)
            return false;
        try {
            const db = yield (0, firebase_1.getFirestoreInstance)();
            let calendarEventsQuery = (0, firestore_1.query)((0, firestore_1.collection)(db, FIRESTORE_COLLECTION), (0, firestore_1.orderBy)("schedule_date", "asc"), (0, firestore_1.limit)(PAGE_SIZE));
            // Conditionally apply the "where" clause if categoryToFilter is available
            if (selectedCategory) {
                calendarEventsQuery = (0, firestore_1.query)(calendarEventsQuery, (0, firestore_1.where)("category", "==", selectedCategory));
            }
            if (lastDocument) {
                calendarEventsQuery = (0, firestore_1.query)(calendarEventsQuery, (0, firestore_1.startAfter)(lastDocument));
            }
            const querySnapshot = yield (0, firestore_1.getDocs)(calendarEventsQuery);
            if (querySnapshot.empty) {
                console.log("No more calendar events to load");
                return false;
            }
            querySnapshot.forEach((doc) => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                const calendarEventData = doc.data();
                const calendarEventElement = document.createElement("div");
                calendarEventElement.classList.add("calendar-event");
                calendarHeader.classList.remove("show", "three-col-layout");
                if (selectedCategory === "Interest Rate") {
                    calendarHeader.classList.add("show");
                    calendarHeader.innerHTML = `
                    <div class="calendar-header-col">Interest Rate</div>
                    <div class="calendar-header-col">Schedule Date</div>
                `;
                    calendarEventElement.innerHTML = `
                    <div class="calendar-event-col">${(_a = calendarEventData.title) === null || _a === void 0 ? void 0 : _a.trim()}</div>
                    <div class="calendar-event-col date">${(0, utils_1.formatDate)((_b = calendarEventData.schedule_date) === null || _b === void 0 ? void 0 : _b.trim())}</div>
                `;
                }
                else if (selectedCategory === "Gross domestic product, income, and expenditure") {
                    calendarHeader.classList.add("show", "three-col-layout");
                    calendarHeader.innerHTML = `
                    <div class="calendar-header-col">Gross domestic product, income, and expenditure</div>
                    <div class="calendar-header-col">Release Date</div>
                    <div class="calendar-header-col">Reference Period</div>
                `;
                    calendarEventElement.classList.add("three-col-layout");
                    calendarEventElement.innerHTML = `
                    <div class="calendar-event-col">${(_c = calendarEventData.title) === null || _c === void 0 ? void 0 : _c.trim()}</div>
                    <div class="calendar-event-col date">${(0, utils_1.formatDate)((_d = calendarEventData.release_date) === null || _d === void 0 ? void 0 : _d.trim())}</div>
                    <div class="calendar-event-col date">${(0, utils_1.formatDate)((_e = calendarEventData.reference_period) === null || _e === void 0 ? void 0 : _e.trim())}</div>
                `;
                }
                else if (selectedCategory === "Housing") {
                    calendarHeader.classList.add("show", "three-col-layout");
                    calendarHeader.innerHTML = `
                    <div class="calendar-header-col">Housing</div>
                    <div class="calendar-header-col">Release Date</div>
                    <div class="calendar-header-col">Last Published Date</div>
                `;
                    calendarEventElement.classList.add("three-col-layout");
                    calendarEventElement.innerHTML = `
                    <div class="calendar-event-col">${(_f = calendarEventData.title) === null || _f === void 0 ? void 0 : _f.trim()}</div>
                    <div class="calendar-event-col date">${(0, utils_1.formatDate)((_g = calendarEventData.release_date) === null || _g === void 0 ? void 0 : _g.trim())}</div>
                    <div class="calendar-event-col date">${(0, utils_1.formatDate)((_h = calendarEventData.last_published_date) === null || _h === void 0 ? void 0 : _h.trim())}</div>
                `;
                }
                calendarEvents.appendChild(calendarEventElement);
            });
            lastDocument = querySnapshot.docs[querySnapshot.docs.length - 1];
            return true;
        }
        catch (error) {
            console.error("Error loading mortgage calendar events:", error);
            return false;
        }
    });
}
